<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t('CONTRACTS.ITEMS') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <building-complexes-contracts-list-filter @setFilters="setFilters" />

      <building-complexes-contracts-list
        :meta="meta"
        :items="items"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="800"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        :building-complex-id="component.data.value.building_complex_id"
        :errors="errors.getAll()"
        @update="updateContract"
        @cancel="cancelDialog"
        @update-prop="clearErrorByName($event)"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import BuildingComplexesContractsListFilter from '@/modules/building_complexes_contracts/components/BuildingComplexesContractsListFilter';
import BuildingComplexesContractsList from '@/modules/building_complexes_contracts/components/BuildingComplexesContractsList';
import { ContractsService } from '@/services/contracts.service';
import { mapActions, mapState } from 'vuex';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'BuildingComplexesContractsPage',
  components: {
    BuildingComplexesContractsList,
    BuildingComplexesContractsListFilter,
    ShowContract: () =>
      import('@/modules/building_complexes_contracts/components/ShowContract')
  },

  mixins: [listOptions],

  data() {
    return {
      dialog: false,
      component: null
    };
  },

  computed: {
    ...mapState('contracts', ['paginationOptions'])
  },

  methods: {
    ...mapActions('contracts', ['getItemsList']),

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },

    show(v) {
      ContractsService.getById(v.id)
        .then(({ data }) => {
          this.dialog = true;
          let value = { ...data };

          if (
            !data.building_ids.length &&
            data.buildings &&
            data.buildings.length
          ) {
            value.building_ids = data.buildings.map(el => el.id);
          }
          this.component = {
            name: 'ShowContract',
            data: {
              value: { ...value },
              details: {
                business_customer: v.building_complex.business_customer,
                management_company: v.building_complex.management_company,
                building_complex_name: v.building_complex.name,
                service: data.service
              }
            }
          };
        })
        .catch(console.error);
    },

    updateContract(form) {
      ContractsService.update(form.id, form)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
        })
        .catch(this.handleErrors);
    }
  }
};
</script>

<style scoped></style>
